import type { Company } from '@viq-admin/types';
import { COMPANY_CRM_FLAGS } from '../companyFlagHelp';

/**
 * The company feature flags under short labels, for the tags on the company
 * page header and the companies list. The Feature flags tab keeps the full
 * names and the help text (companyFlagHelp.ts).
 */

type FlagKey = keyof Pick<
  Company,
  | 'storeCardImages'
  | 'leadMoveEnabled'
  | 'autoEnrichApollo'
  | 'crmHubspotEnabled'
  | 'crmSalesforceEnabled'
  | 'crmZohoEnabled'
>;

/** Every flag in the order the console shows them; CRM providers last. */
export const COMPANY_FEATURES: ReadonlyArray<{ key: FlagKey; label: string; crm: boolean }> = [
  { key: 'storeCardImages', label: 'Card images', crm: false },
  { key: 'leadMoveEnabled', label: 'Move leads', crm: false },
  { key: 'autoEnrichApollo', label: 'Auto enrichment', crm: false },
  ...COMPANY_CRM_FLAGS.map(({ name, label }) => ({ key: name, label, crm: true })),
];

/** The flags that are on. A missing field (an older row) reads as off. */
export function enabledFeatures(company: Partial<Company>) {
  return COMPANY_FEATURES.filter((f) => company[f.key] === true);
}
